<template>
  <div id="linkedPages">
    <div v-for="page in pages" v-bind:key="page.id" class="card my-3">
      <a :href="page.route" style="color: inherit;" class="btn">
        <div class="row align-items-center justify-content-center">
          <div class="col-3 col-md-10 col-lg-8 col-xl-4">
            <img class="img-fluid" :src="page.small_image_url" alt="logo" />
          </div>
          <div class="col-5 col-md-12 col-xl-8 my-2">
            <p class="text-center mb-0">{{ page.name }}</p>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkedPages",

  data() {
    return {
      pages: [],
      loading: true
    };
  },

  created() {
    this.loadLinkedPages();
  },

  methods: {
    loadLinkedPages() {
      this.loading = true;
      var self = this;
      axios
        .get("api/linkedpages")
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length)
          self.pages = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>